// extracted by mini-css-extract-plugin
module.exports = {"Bio":"Bio_Bio__2TPK3","About":"Bio_About__3XlHN","Image":"Bio_Image__2RdPX"};